export const icebergBronzeData = {
  took: 7,
  timed_out: false,
  _shards: {
    total: 22,
    successful: 22,
    skipped: 20,
    failed: 0,
  },
  hits: {
    total: {
      value: 14,
      relation: 'eq',
    },
    max_score: null,
    hits: [
      {
        _index: 'table_search_index',
        _id: '9bd93c80-515e-469d-b18d-692f09988315',
        _score: null,
        _source: {
          databaseSchema: {
            deleted: false,
            displayName: 'g_turbo',
            name: 'g_turbo',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>가디원 터보 원천 데이터</p><ul class="om-list-disc"><li class="om-leading-normal"><p>베어링 시트지</p></li><li class="om-leading-normal"><p>Chart &amp; Trend 테이블</p></li><li class="om-leading-normal"><p>tag_id / rpm 매핑 테이블 (메타 데이터)</p></li><li class="om-leading-normal"><p>개인 작업용 </p></li><li class="om-leading-normal"><p>etc ..</p><p></p></li></ul></li></ul><p></p>',
            id: '47b43540-aa17-4b11-8f43-d2fb6489ef48',
            type: 'databaseSchema',
            fullyQualifiedName: 'bronze-iceberg.bronze.g_turbo',
          },
          serviceType: 'Iceberg',
          displayName: 'kmp_ecms_bearings1',
          schemaDefinition: null,
          description:
            '<ul class="om-list-disc"><li class="om-leading-normal"><p>KMP 베어링 시트지</p><ul class="om-list-disc"><li class="om-leading-normal"><p>터빈 베어링 진단 알고리즘에 활용되는 config 정보</p></li></ul></li></ul><p></p>',
          owners: [
            {
              deleted: false,
              displayName: 'DI',
              inherited: true,
              name: 'DI',
              description:
                '<ul class="om-list-disc"><li class="om-leading-normal"><p>데이터 과학자, 분석가 소속 팀</p></li></ul><p></p>',
              id: '3b28a5be-4517-48f0-84f4-01ae147493bd',
              type: 'team',
              fullyQualifiedName: 'DI',
            },
          ],
          tierSources: {},
          fqnHash:
            'd3e099f4de5c79f8999f7fccaf37c881.cab7e764b30007514145eaf2f6a7ed0f.5df9be687e674cc4273916ac1fa9a834.8177d2d0976ca6740ff13858f327c01b',
          customMetrics: [],
          tableType: 'Regular',
          database: {
            deleted: false,
            displayName: 'bronze',
            name: 'bronze',
            id: '86937770-97d6-40ea-99b9-d7e30effef15',
            type: 'database',
            fullyQualifiedName: 'bronze-iceberg.bronze',
          },
          descriptionStatus: 'COMPLETE',
          columnNames: [
            'id',
            'sequence',
            'bearing_name',
            'train_id',
            'rotor_id',
            'administrator',
            'vms_type',
            'bearing_type',
            'asset_type',
            'critical_speed',
            'rated_speed',
            'direction',
            'neighbor_id',
            'x_tag',
            'y_tag',
            'x_gap_tag',
            'y_gap_tag',
            'x_1x_tag',
            'y_1x_tag',
            'rpm_tag',
            'phase_x_tag',
            'phase_y_tag',
            'process_vib_x',
            'process_vib_y',
            'process_temperature',
            'asset_seq',
            'iso_a',
            'iso_b',
            'iso_c',
            'vib_threshold_h',
            'vib_threshold_hh',
            'temperature_threshold_h',
            'temperature_threshold_hh',
            'source_unit',
            'vib_xy_threshold',
            'sensor_x',
            'sensor_y',
          ],
          tier: null,
          totalVotes: 0,
          usageSummary: {
            date: '2026-03-26',
            weeklyStats: {
              percentileRank: 0,
              count: 0,
            },
            monthlyStats: {
              percentileRank: 0,
              count: 0,
            },
            dailyStats: {
              percentileRank: 0,
              count: 0,
            },
          },
          id: '9bd93c80-515e-469d-b18d-692f09988315',
          columnDescriptionStatus: 'INCOMPLETE',
          upstreamEntityRelationship: [],
          updatedAt: 1767664559233,
          columnNamesFuzzy:
            'id sequence bearing_name train_id rotor_id administrator vms_type bearing_type asset_type critical_speed rated_speed direction neighbor_id x_tag y_tag x_gap_tag y_gap_tag x_1x_tag y_1x_tag rpm_tag phase_x_tag phase_y_tag process_vib_x process_vib_y process_temperature asset_seq iso_a iso_b iso_c vib_threshold_h vib_threshold_hh temperature_threshold_h temperature_threshold_hh source_unit vib_xy_threshold sensor_x sensor_y',
          descriptionSources: {
            Manual: 1,
          },
          updatedBy: 'jaejun.lee',
          entityType: 'table',
          domains: [],
          dataProducts: [],
          fullyQualifiedName: 'bronze-iceberg.bronze.g_turbo.kmp_ecms_bearings1',
          version: 0.2,
          queries: [],
          certification: {
            tagLabel: {
              tagFQN: 'Certification.Bronze',
              name: 'Bronze',
              labelType: 'Manual',
              description: 'Bronze certified Data Asset',
              style: {
                color: '#C08329',
                iconURL: 'BronzeCertification.svg',
              },
              source: 'Classification',
              state: 'Confirmed',
            },
          },
          tags: [
            {
              tagFQN: 'Equipment Type.터빈',
              name: '터빈',
              displayName: '터빈',
              description: '터빈 설비 관련 데이터',
              source: 'Classification',
              labelType: 'Manual',
              state: 'Confirmed',
            },
          ],
          terms: [
            {
              id: 'term-vibration',
              type: 'glossaryTerm',
              name: 'Vibration',
              displayName: '진동',
              fullyQualifiedName: 'Manufacturing.Vibration',
              deleted: false,
            },
            {
              id: 'term-bearing',
              type: 'glossaryTerm',
              name: 'Bearing',
              displayName: '베어링',
              fullyQualifiedName: 'Manufacturing.Bearing',
              deleted: false,
            },
          ],
          sourceHash: '539f8a5832ef81af03163ef6c27ca47c',
          followers: [],
          deleted: false,
          service: {
            deleted: false,
            displayName: 'bronze-iceberg',
            name: 'bronze-iceberg',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>Bronze Tier Iceberg</p></li></ul><p></p>',
            id: '04812691-e812-4edb-b69a-960faa6b842f',
            type: 'databaseService',
            fullyQualifiedName: 'bronze-iceberg',
          },
          name: 'kmp_ecms_bearings1',
          processedLineage: false,
          tagSources: {},
          upstreamLineage: [],
          locationPath: null,
          fqnParts: [
            'g_turbo',
            'bronze-iceberg.bronze.g_turbo.kmp_ecms_bearings1',
            'g_turbo.kmp_ecms_bearings1',
            'bronze-iceberg.bronze.g_turbo',
            'bronze-iceberg',
            'bronze.g_turbo',
            'bronze.g_turbo.kmp_ecms_bearings1',
            'bronze-iceberg.bronze',
            'bronze',
          ],
        },
        sort: [0],
      },
      {
        _index: 'table_search_index',
        _id: 'a43c299e-4e8e-456f-a40e-c3149599c2c5',
        _score: null,
        _source: {
          databaseSchema: {
            deleted: false,
            displayName: 'g_turbo',
            name: 'g_turbo',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>가디원 터보 원천 데이터</p><ul class="om-list-disc"><li class="om-leading-normal"><p>베어링 시트지</p></li><li class="om-leading-normal"><p>Chart &amp; Trend 테이블</p></li><li class="om-leading-normal"><p>tag_id / rpm 매핑 테이블 (메타 데이터)</p></li><li class="om-leading-normal"><p>개인 작업용 </p></li><li class="om-leading-normal"><p>etc ..</p><p></p></li></ul></li></ul><p></p>',
            id: '47b43540-aa17-4b11-8f43-d2fb6489ef48',
            type: 'databaseSchema',
            fullyQualifiedName: 'bronze-iceberg.bronze.g_turbo',
          },
          serviceType: 'Iceberg',
          displayName: 'gsc_bearings',
          schemaDefinition: null,
          description:
            '<ul class="om-list-disc"><li class="om-leading-normal"><p>GSC 베어링 시트지 </p><ul class="om-list-disc"><li class="om-leading-normal"><p>터빈 베어링 진단 알고리즘에 활용되는 config 정보 </p></li></ul></li></ul><p></p>',
          owners: [
            {
              deleted: false,
              displayName: 'DI',
              inherited: true,
              name: 'DI',
              description:
                '<ul class="om-list-disc"><li class="om-leading-normal"><p>데이터 과학자, 분석가 소속 팀</p></li></ul><p></p>',
              id: '3b28a5be-4517-48f0-84f4-01ae147493bd',
              type: 'team',
              fullyQualifiedName: 'DI',
            },
          ],
          tierSources: {},
          fqnHash:
            'd3e099f4de5c79f8999f7fccaf37c881.cab7e764b30007514145eaf2f6a7ed0f.5df9be687e674cc4273916ac1fa9a834.1d11fc0da0498822531e1cee63e44a01',
          customMetrics: [],
          tableType: 'Regular',
          database: {
            deleted: false,
            displayName: 'bronze',
            name: 'bronze',
            id: '86937770-97d6-40ea-99b9-d7e30effef15',
            type: 'database',
            fullyQualifiedName: 'bronze-iceberg.bronze',
          },
          descriptionStatus: 'COMPLETE',
          columnNames: [
            'id',
            'rotor_id',
            'train_id',
            'administrator',
            'vms_type',
            'bearing_type',
            'asset_type',
            'critical_speed',
            'rated_speed',
            'direction',
            'neighbor_id',
            'x_tag',
            'y_tag',
            'x_p2p',
            'y_p2p',
            'x_gap_tag',
            'y_gap_tag',
            'x_1x_tag',
            'y_1x_tag',
            'phase_x_tag',
            'phase_y_tag',
            'rpm_tag',
            'process_vib_x',
            'process_vib_y',
            'process_temperature',
            'asset_seq',
            'iso_a',
            'iso_b',
            'iso_c',
            'vib_threshold_h',
            'vib_threshold_hh',
            'temperature_threshold_h',
            'temperature_threshold_hh',
            'source_unit',
            'sensor_x',
            'sensor_y',
            'bearing_order',
            'bearing_name',
          ],
          tier: null,
          totalVotes: 0,
          usageSummary: {
            date: '2026-03-26',
            weeklyStats: {
              percentileRank: 0,
              count: 0,
            },
            monthlyStats: {
              percentileRank: 0,
              count: 0,
            },
            dailyStats: {
              percentileRank: 0,
              count: 0,
            },
          },
          id: 'a43c299e-4e8e-456f-a40e-c3149599c2c5',
          columnDescriptionStatus: 'INCOMPLETE',
          upstreamEntityRelationship: [],
          updatedAt: 1761292909980,
          columnNamesFuzzy:
            'id rotor_id train_id administrator vms_type bearing_type asset_type critical_speed rated_speed direction neighbor_id x_tag y_tag x_p2p y_p2p x_gap_tag y_gap_tag x_1x_tag y_1x_tag phase_x_tag phase_y_tag rpm_tag process_vib_x process_vib_y process_temperature asset_seq iso_a iso_b iso_c vib_threshold_h vib_threshold_hh temperature_threshold_h temperature_threshold_hh source_unit sensor_x sensor_y bearing_order bearing_name',
          descriptionSources: {
            Manual: 6,
          },
          updatedBy: 'ingestion-bot',
          entityType: 'table',
          domains: [],
          dataProducts: [],
          fullyQualifiedName: 'bronze-iceberg.bronze.g_turbo.gsc_bearings',
          version: 0.4,
          queries: [],
          certification: {
            tagLabel: {
              tagFQN: 'Certification.Bronze',
              name: 'Bronze',
              labelType: 'Manual',
              description: 'Bronze certified Data Asset',
              style: {
                color: '#C08329',
                iconURL: 'BronzeCertification.svg',
              },
              source: 'Classification',
              state: 'Confirmed',
            },
          },
          tags: [
            {
              tagFQN: 'Equipment Type.터빈',
              name: '터빈',
              displayName: '터빈',
              description: '터빈 설비 관련 데이터',
              source: 'Classification',
              labelType: 'Manual',
              state: 'Confirmed',
            },
            {
              tagFQN: 'Equipment Type.CNC_Lathe',
              name: 'CNC_Lathe',
              displayName: 'CNC Lathe',
              description: 'CNC 선반 설비 관련 데이터',
              source: 'Classification',
              labelType: 'Manual',
              state: 'Confirmed',
            },
          ],
          terms: [
            {
              id: 'term-bearing',
              type: 'glossaryTerm',
              name: 'Bearing',
              displayName: '베어링',
              fullyQualifiedName: 'Manufacturing.Bearing',
              deleted: false,
            },
            {
              id: 'term-vibration',
              type: 'glossaryTerm',
              name: 'Vibration',
              displayName: '진동',
              fullyQualifiedName: 'Manufacturing.Vibration',
              deleted: false,
            },
          ],
          sourceHash: 'f892310fe1b0934835a4aa5d306389e3',
          followers: [],
          deleted: false,
          service: {
            deleted: false,
            displayName: 'bronze-iceberg',
            name: 'bronze-iceberg',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>Bronze Tier Iceberg</p></li></ul><p></p>',
            id: '04812691-e812-4edb-b69a-960faa6b842f',
            type: 'databaseService',
            fullyQualifiedName: 'bronze-iceberg',
          },
          name: 'gsc_bearings',
          processedLineage: false,
          tagSources: {},
          upstreamLineage: [],
          locationPath: null,
          fqnParts: [
            'g_turbo.gsc_bearings',
            'g_turbo',
            'bronze-iceberg.bronze.g_turbo',
            'bronze-iceberg.bronze.g_turbo.gsc_bearings',
            'bronze.g_turbo.gsc_bearings',
            'bronze-iceberg',
            'bronze.g_turbo',
            'bronze-iceberg.bronze',
            'bronze',
          ],
        },
        sort: [0],
      },
      {
        _index: 'table_search_index',
        _id: 'edc02995-5f17-4337-bf68-1f1cc50de439',
        _score: null,
        _source: {
          databaseSchema: {
            deleted: false,
            displayName: 'g_turbo',
            name: 'g_turbo',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>가디원 터보 원천 데이터</p><ul class="om-list-disc"><li class="om-leading-normal"><p>베어링 시트지</p></li><li class="om-leading-normal"><p>Chart &amp; Trend 테이블</p></li><li class="om-leading-normal"><p>tag_id / rpm 매핑 테이블 (메타 데이터)</p></li><li class="om-leading-normal"><p>개인 작업용 </p></li><li class="om-leading-normal"><p>etc ..</p><p></p></li></ul></li></ul><p></p>',
            id: '47b43540-aa17-4b11-8f43-d2fb6489ef48',
            type: 'databaseSchema',
            fullyQualifiedName: 'bronze-iceberg.bronze.g_turbo',
          },
          serviceType: 'Iceberg',
          displayName: 'hanwha_impact_bearings1',
          schemaDefinition: null,
          description:
            '<ul class="om-list-disc"><li class="om-leading-normal"><p>한화 임팩트 베어링 시트지1</p></li></ul><p></p>',
          owners: [
            {
              deleted: false,
              displayName: 'DI',
              inherited: true,
              name: 'DI',
              description:
                '<ul class="om-list-disc"><li class="om-leading-normal"><p>데이터 과학자, 분석가 소속 팀</p></li></ul><p></p>',
              id: '3b28a5be-4517-48f0-84f4-01ae147493bd',
              type: 'team',
              fullyQualifiedName: 'DI',
            },
          ],
          tierSources: {},
          fqnHash:
            'd3e099f4de5c79f8999f7fccaf37c881.cab7e764b30007514145eaf2f6a7ed0f.5df9be687e674cc4273916ac1fa9a834.a66e61c366324ca6e515d8afbf21c9ad',
          customMetrics: [],
          tableType: 'Regular',
          database: {
            deleted: false,
            displayName: 'bronze',
            name: 'bronze',
            id: '86937770-97d6-40ea-99b9-d7e30effef15',
            type: 'database',
            fullyQualifiedName: 'bronze-iceberg.bronze',
          },
          descriptionStatus: 'COMPLETE',
          columnNames: [
            'id',
            'sequence',
            'bearing_name',
            'train_id',
            'rotor_id',
            'administrator',
            'vms_type',
            'bearing_type',
            'asset_type',
            'critical_speed',
            'rated_speed',
            'direction',
            'neighbor_id',
            'x_tag',
            'y_tag',
            'x_gap_tag',
            'y_gap_tag',
            'x_1x_tag',
            'y_1x_tag',
            'rpm_tag',
            'phase_x_tag',
            'phase_y_tag',
            'process_vib_x',
            'process_vib_y',
            'process_temperature',
            'asset_seq',
            'iso_a',
            'iso_b',
            'iso_c',
            'vib_threshold_h',
            'vib_threshold_hh',
            'temperature_threshold_h',
            'temperature_threshold_hh',
            'source_unit',
            'vib_xy_threshold',
            'sensor_x',
            'sensor_y',
            'origin_x_tag',
            'origin_y_tag',
          ],
          tier: null,
          totalVotes: 0,
          usageSummary: {
            date: '2026-03-26',
            weeklyStats: {
              percentileRank: 0,
              count: 0,
            },
            monthlyStats: {
              percentileRank: 0,
              count: 0,
            },
            dailyStats: {
              percentileRank: 0,
              count: 0,
            },
          },
          id: 'edc02995-5f17-4337-bf68-1f1cc50de439',
          columnDescriptionStatus: 'INCOMPLETE',
          upstreamEntityRelationship: [],
          updatedAt: 1761615075742,
          columnNamesFuzzy:
            'id sequence bearing_name train_id rotor_id administrator vms_type bearing_type asset_type critical_speed rated_speed direction neighbor_id x_tag y_tag x_gap_tag y_gap_tag x_1x_tag y_1x_tag rpm_tag phase_x_tag phase_y_tag process_vib_x process_vib_y process_temperature asset_seq iso_a iso_b iso_c vib_threshold_h vib_threshold_hh temperature_threshold_h temperature_threshold_hh source_unit vib_xy_threshold sensor_x sensor_y origin_x_tag origin_y_tag',
          descriptionSources: {
            Manual: 1,
          },
          updatedBy: 'jaejun.lee',
          entityType: 'table',
          domains: [],
          dataProducts: [],
          fullyQualifiedName: 'bronze-iceberg.bronze.g_turbo.hanwha_impact_bearings1',
          version: 1.4,
          queries: [],
          certification: {
            tagLabel: {
              tagFQN: 'Certification.Bronze',
              name: 'Bronze',
              labelType: 'Manual',
              description: 'Bronze certified Data Asset',
              style: {
                color: '#C08329',
                iconURL: 'BronzeCertification.svg',
              },
              source: 'Classification',
              state: 'Confirmed',
            },
          },
          tags: [
            {
              tagFQN: 'Equipment Type.Furnace',
              name: 'Furnace',
              displayName: 'Furnace',
              description: '용광로 설비 관련 데이터',
              source: 'Classification',
              labelType: 'Manual',
              state: 'Confirmed',
            },
            {
              tagFQN: 'Equipment Type.사출기',
              name: '사출기',
              displayName: '사출기',
              description: '사출 성형 설비 관련 데이터',
              source: 'Classification',
              labelType: 'Manual',
              state: 'Confirmed',
            },
          ],
          terms: [
            {
              id: 'term-bearing',
              type: 'glossaryTerm',
              name: 'Bearing',
              displayName: '베어링',
              fullyQualifiedName: 'Manufacturing.Bearing',
              deleted: false,
            },
            {
              id: 'term-vibration',
              type: 'glossaryTerm',
              name: 'Vibration',
              displayName: '진동',
              fullyQualifiedName: 'Manufacturing.Vibration',
              deleted: false,
            },
          ],
          sourceHash: 'e3247da43ca3a88ac9df13bfb8391303',
          followers: [],
          deleted: false,
          service: {
            deleted: false,
            displayName: 'bronze-iceberg',
            name: 'bronze-iceberg',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>Bronze Tier Iceberg</p></li></ul><p></p>',
            id: '04812691-e812-4edb-b69a-960faa6b842f',
            type: 'databaseService',
            fullyQualifiedName: 'bronze-iceberg',
          },
          name: 'hanwha_impact_bearings1',
          processedLineage: false,
          tagSources: {},
          upstreamLineage: [],
          locationPath: null,
          fqnParts: [
            'bronze.g_turbo.hanwha_impact_bearings1',
            'g_turbo',
            'bronze-iceberg.bronze.g_turbo.hanwha_impact_bearings1',
            'bronze-iceberg.bronze.g_turbo',
            'g_turbo.hanwha_impact_bearings1',
            'bronze-iceberg',
            'bronze.g_turbo',
            'bronze-iceberg.bronze',
            'bronze',
          ],
        },
        sort: [0],
      },
      {
        _index: 'table_search_index',
        _id: 'fb93e3f5-d337-44de-8e07-cd528444c40c',
        _score: null,
        _source: {
          databaseSchema: {
            deleted: false,
            displayName: 'g_turbo',
            name: 'g_turbo',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>가디원 터보 원천 데이터</p><ul class="om-list-disc"><li class="om-leading-normal"><p>베어링 시트지</p></li><li class="om-leading-normal"><p>Chart &amp; Trend 테이블</p></li><li class="om-leading-normal"><p>tag_id / rpm 매핑 테이블 (메타 데이터)</p></li><li class="om-leading-normal"><p>개인 작업용 </p></li><li class="om-leading-normal"><p>etc ..</p><p></p></li></ul></li></ul><p></p>',
            id: '47b43540-aa17-4b11-8f43-d2fb6489ef48',
            type: 'databaseSchema',
            fullyQualifiedName: 'bronze-iceberg.bronze.g_turbo',
          },
          serviceType: 'Iceberg',
          displayName: 'gsp_ecms1_chart',
          schemaDefinition: null,
          description:
            '<ul class="om-list-disc"><li class="om-leading-normal"><p>GSP ECMS1 Chart 테이블</p><ul class="om-list-disc"><li class="om-leading-normal"><p>tag_id</p></li><li class="om-leading-normal"><p>진동 신호 원천 데이터</p></li><li class="om-leading-normal"><p>async/sync</p></li><li class="om-leading-normal"><p>rpm</p></li></ul></li></ul><p></p>',
          owners: [
            {
              deleted: false,
              displayName: 'DI',
              inherited: true,
              name: 'DI',
              description:
                '<ul class="om-list-disc"><li class="om-leading-normal"><p>데이터 과학자, 분석가 소속 팀</p></li></ul><p></p>',
              id: '3b28a5be-4517-48f0-84f4-01ae147493bd',
              type: 'team',
              fullyQualifiedName: 'DI',
            },
          ],
          tierSources: {},
          fqnHash:
            'd3e099f4de5c79f8999f7fccaf37c881.cab7e764b30007514145eaf2f6a7ed0f.5df9be687e674cc4273916ac1fa9a834.a9b2f5c53c3e7eb88ce5e1fe4c614b60',
          customMetrics: [],
          tableType: 'Regular',
          database: {
            deleted: false,
            displayName: 'bronze',
            name: 'bronze',
            id: '86937770-97d6-40ea-99b9-d7e30effef15',
            type: 'database',
            fullyQualifiedName: 'bronze-iceberg.bronze',
          },
          descriptionStatus: 'COMPLETE',
          columnNames: [
            'chart_id',
            'tag_id',
            'meas_start_dt',
            'chart_type',
            'mean_val',
            'lines',
            'scale_factor',
            'reg_dt',
            'freq',
            'per_bit',
            'sample_rate',
            'chart_data',
            'rpm',
          ],
          tier: null,
          totalVotes: 0,
          usageSummary: {
            date: '2026-03-26',
            weeklyStats: {
              percentileRank: 0,
              count: 0,
            },
            monthlyStats: {
              percentileRank: 0,
              count: 0,
            },
            dailyStats: {
              percentileRank: 0,
              count: 0,
            },
          },
          id: 'fb93e3f5-d337-44de-8e07-cd528444c40c',
          columnDescriptionStatus: 'INCOMPLETE',
          upstreamEntityRelationship: [],
          updatedAt: 1761725608156,
          columnNamesFuzzy:
            'chart_id tag_id meas_start_dt chart_type mean_val lines scale_factor reg_dt freq per_bit sample_rate chart_data rpm',
          descriptionSources: {
            Manual: 9,
          },
          updatedBy: 'jaejun.lee',
          entityType: 'table',
          domains: [],
          dataProducts: [],
          fullyQualifiedName: 'bronze-iceberg.bronze.g_turbo.gsp_ecms1_chart',
          version: 0.3,
          queries: [],
          certification: {
            tagLabel: {
              tagFQN: 'Certification.Bronze',
              name: 'Bronze',
              labelType: 'Manual',
              description: 'Bronze certified Data Asset',
              style: {
                color: '#C08329',
                iconURL: 'BronzeCertification.svg',
              },
              source: 'Classification',
              state: 'Confirmed',
            },
          },
          tags: [
            {
              tagFQN: 'Equipment Type.CNC_Lathe',
              name: 'CNC_Lathe',
              displayName: 'CNC Lathe',
              description: 'CNC 선반 설비 관련 데이터',
              source: 'Classification',
              labelType: 'Manual',
              state: 'Confirmed',
            },
          ],
          terms: [
            {
              id: 'term-vibration',
              type: 'glossaryTerm',
              name: 'Vibration',
              displayName: '진동',
              fullyQualifiedName: 'Manufacturing.Vibration',
              deleted: false,
            },
            {
              id: 'term-temperature',
              type: 'glossaryTerm',
              name: 'Temperature',
              displayName: '온도',
              fullyQualifiedName: 'Manufacturing.Temperature',
              deleted: false,
            },
          ],
          sourceHash: '39b831c142f8f2cb9a4dbcf23e256a3a',
          followers: [],
          deleted: false,
          service: {
            deleted: false,
            displayName: 'bronze-iceberg',
            name: 'bronze-iceberg',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>Bronze Tier Iceberg</p></li></ul><p></p>',
            id: '04812691-e812-4edb-b69a-960faa6b842f',
            type: 'databaseService',
            fullyQualifiedName: 'bronze-iceberg',
          },
          name: 'gsp_ecms1_chart',
          processedLineage: false,
          tablePartition: {
            columns: [
              {
                intervalType: 'INTEGER-RANGE',
                columnName: 'tag_id',
              },
              {
                intervalType: 'COLUMN-VALUE',
                columnName: 'chart_type',
              },
            ],
          },
          tagSources: {},
          upstreamLineage: [],
          locationPath: null,
          fqnParts: [
            'g_turbo',
            'bronze.g_turbo.gsp_ecms1_chart',
            'bronze-iceberg.bronze.g_turbo.gsp_ecms1_chart',
            'bronze-iceberg.bronze.g_turbo',
            'bronze-iceberg',
            'bronze.g_turbo',
            'bronze-iceberg.bronze',
            'bronze',
            'g_turbo.gsp_ecms1_chart',
          ],
        },
        sort: [0],
      },
      {
        _index: 'table_search_index',
        _id: '3c18c183-3c0e-4f2a-8b02-09785dac0683',
        _score: null,
        _source: {
          databaseSchema: {
            deleted: false,
            displayName: 'g_turbo',
            name: 'g_turbo',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>가디원 터보 원천 데이터</p><ul class="om-list-disc"><li class="om-leading-normal"><p>베어링 시트지</p></li><li class="om-leading-normal"><p>Chart &amp; Trend 테이블</p></li><li class="om-leading-normal"><p>tag_id / rpm 매핑 테이블 (메타 데이터)</p></li><li class="om-leading-normal"><p>개인 작업용 </p></li><li class="om-leading-normal"><p>etc ..</p><p></p></li></ul></li></ul><p></p>',
            id: '47b43540-aa17-4b11-8f43-d2fb6489ef48',
            type: 'databaseSchema',
            fullyQualifiedName: 'bronze-iceberg.bronze.g_turbo',
          },
          serviceType: 'Iceberg',
          displayName: 'kmp_ecms_trend',
          schemaDefinition: null,
          description:
            '<ul class="om-list-disc"><li class="om-leading-normal"><p>KM[P ECMS Trend 테이블</p><ul class="om-list-disc"><li class="om-leading-normal"><p>tag_id에 따른 peak-to-peak 정보를 가지고 있다.</p></li><li class="om-leading-normal"><p>해당 테이블은 Chart 테이블에서 진동 데이터를 활용하여 peak to peak 값을 생성 후 적재 하였다.</p></li></ul></li></ul><p></p>',
          owners: [
            {
              deleted: false,
              displayName: 'DI',
              inherited: true,
              name: 'DI',
              description:
                '<ul class="om-list-disc"><li class="om-leading-normal"><p>데이터 과학자, 분석가 소속 팀</p></li></ul><p></p>',
              id: '3b28a5be-4517-48f0-84f4-01ae147493bd',
              type: 'team',
              fullyQualifiedName: 'DI',
            },
          ],
          tierSources: {},
          fqnHash:
            'd3e099f4de5c79f8999f7fccaf37c881.cab7e764b30007514145eaf2f6a7ed0f.5df9be687e674cc4273916ac1fa9a834.c812a2fe95072f58adba38c70fc5c817',
          customMetrics: [],
          tableType: 'Regular',
          database: {
            deleted: false,
            displayName: 'bronze',
            name: 'bronze',
            id: '86937770-97d6-40ea-99b9-d7e30effef15',
            type: 'database',
            fullyQualifiedName: 'bronze-iceberg.bronze',
          },
          descriptionStatus: 'COMPLETE',
          columnNames: ['tag_id', 'meas_dt', 'mean_val'],
          tier: null,
          totalVotes: 0,
          usageSummary: {
            date: '2026-03-26',
            weeklyStats: {
              percentileRank: 0,
              count: 0,
            },
            monthlyStats: {
              percentileRank: 0,
              count: 0,
            },
            dailyStats: {
              percentileRank: 0,
              count: 0,
            },
          },
          id: '3c18c183-3c0e-4f2a-8b02-09785dac0683',
          columnDescriptionStatus: 'INCOMPLETE',
          upstreamEntityRelationship: [],
          updatedAt: 1767664675722,
          columnNamesFuzzy: 'tag_id meas_dt mean_val',
          descriptionSources: {
            Manual: 1,
          },
          updatedBy: 'jaejun.lee',
          entityType: 'table',
          domains: [],
          dataProducts: [],
          fullyQualifiedName: 'bronze-iceberg.bronze.g_turbo.kmp_ecms_trend',
          version: 0.2,
          queries: [],
          certification: {
            tagLabel: {
              tagFQN: 'Certification.Bronze',
              name: 'Bronze',
              labelType: 'Manual',
              description: 'Bronze certified Data Asset',
              style: {
                color: '#C08329',
                iconURL: 'BronzeCertification.svg',
              },
              source: 'Classification',
              state: 'Confirmed',
            },
          },
          tags: [
            {
              tagFQN: 'Equipment Type.터빈',
              name: '터빈',
              displayName: '터빈',
              description: '터빈 설비 관련 데이터',
              source: 'Classification',
              labelType: 'Manual',
              state: 'Confirmed',
            },
          ],
          terms: [
            {
              id: 'term-vibration',
              type: 'glossaryTerm',
              name: 'Vibration',
              displayName: '진동',
              fullyQualifiedName: 'Manufacturing.Vibration',
              deleted: false,
            },
          ],
          sourceHash: '2ac000f66d98a27dd3b7993f64ea301a',
          followers: [],
          deleted: false,
          service: {
            deleted: false,
            displayName: 'bronze-iceberg',
            name: 'bronze-iceberg',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>Bronze Tier Iceberg</p></li></ul><p></p>',
            id: '04812691-e812-4edb-b69a-960faa6b842f',
            type: 'databaseService',
            fullyQualifiedName: 'bronze-iceberg',
          },
          name: 'kmp_ecms_trend',
          processedLineage: false,
          tagSources: {},
          upstreamLineage: [],
          locationPath: null,
          fqnParts: [
            'g_turbo',
            'bronze-iceberg.bronze.g_turbo.kmp_ecms_trend',
            'bronze-iceberg.bronze.g_turbo',
            'bronze-iceberg',
            'bronze.g_turbo',
            'bronze.g_turbo.kmp_ecms_trend',
            'bronze-iceberg.bronze',
            'bronze',
            'g_turbo.kmp_ecms_trend',
          ],
        },
        sort: [0],
      },
      {
        _index: 'table_search_index',
        _id: '41b039b9-6342-4783-aef9-0515f68d7498',
        _score: null,
        _source: {
          databaseSchema: {
            deleted: false,
            displayName: 'g_turbo',
            name: 'g_turbo',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>가디원 터보 원천 데이터</p><ul class="om-list-disc"><li class="om-leading-normal"><p>베어링 시트지</p></li><li class="om-leading-normal"><p>Chart &amp; Trend 테이블</p></li><li class="om-leading-normal"><p>tag_id / rpm 매핑 테이블 (메타 데이터)</p></li><li class="om-leading-normal"><p>개인 작업용 </p></li><li class="om-leading-normal"><p>etc ..</p><p></p></li></ul></li></ul><p></p>',
            id: '47b43540-aa17-4b11-8f43-d2fb6489ef48',
            type: 'databaseSchema',
            fullyQualifiedName: 'bronze-iceberg.bronze.g_turbo',
          },
          serviceType: 'Iceberg',
          displayName: 'gsp_dcs',
          schemaDefinition: null,
          description:
            '<ul class="om-list-disc"><li class="om-leading-normal"><p>GSP DCS 운영 인자 데이터</p></li></ul><p></p>',
          owners: [
            {
              deleted: false,
              displayName: 'DI',
              inherited: true,
              name: 'DI',
              description:
                '<ul class="om-list-disc"><li class="om-leading-normal"><p>데이터 과학자, 분석가 소속 팀</p></li></ul><p></p>',
              id: '3b28a5be-4517-48f0-84f4-01ae147493bd',
              type: 'team',
              fullyQualifiedName: 'DI',
            },
          ],
          tierSources: {},
          fqnHash:
            'd3e099f4de5c79f8999f7fccaf37c881.cab7e764b30007514145eaf2f6a7ed0f.5df9be687e674cc4273916ac1fa9a834.b3f785decb596758e81868dc0ced999d',
          customMetrics: [],
          tableType: 'Regular',
          database: {
            deleted: false,
            displayName: 'bronze',
            name: 'bronze',
            id: '86937770-97d6-40ea-99b9-d7e30effef15',
            type: 'database',
            fullyQualifiedName: 'bronze-iceberg.bronze',
          },
          descriptionStatus: 'COMPLETE',
          columnNames: [
            'acq_time',
            'process_data',
            'process_data_info_id',
            'turbine_id',
            'tag_code',
            'tag_value',
            'machine_category',
            'equipment_category',
            'description',
            'unit',
          ],
          tier: null,
          totalVotes: 0,
          usageSummary: {
            date: '2026-03-26',
            weeklyStats: {
              percentileRank: 0,
              count: 0,
            },
            monthlyStats: {
              percentileRank: 0,
              count: 0,
            },
            dailyStats: {
              percentileRank: 0,
              count: 0,
            },
          },
          id: '41b039b9-6342-4783-aef9-0515f68d7498',
          columnDescriptionStatus: 'INCOMPLETE',
          upstreamEntityRelationship: [],
          updatedAt: 1768544343163,
          columnNamesFuzzy:
            'acq_time process_data process_data_info_id turbine_id tag_code tag_value machine_category equipment_category description unit',
          descriptionSources: {
            Manual: 1,
          },
          updatedBy: 'jaejun.lee',
          entityType: 'table',
          domains: [],
          dataProducts: [],
          fullyQualifiedName: 'bronze-iceberg.bronze.g_turbo.gsp_dcs',
          version: 0.2,
          queries: [],
          certification: {
            tagLabel: {
              tagFQN: 'Certification.Bronze',
              name: 'Bronze',
              labelType: 'Manual',
              description: 'Bronze certified Data Asset',
              style: {
                color: '#C08329',
                iconURL: 'BronzeCertification.svg',
              },
              source: 'Classification',
              state: 'Confirmed',
            },
          },
          tags: [
            {
              tagFQN: 'Equipment Type.CNC_Lathe',
              name: 'CNC_Lathe',
              displayName: 'CNC Lathe',
              description: 'CNC 선반 설비 관련 데이터',
              source: 'Classification',
              labelType: 'Manual',
              state: 'Confirmed',
            },
            {
              tagFQN: 'Equipment Type.Hi-Mold',
              name: 'Hi-Mold',
              displayName: 'Hi-Mold',
              description: '하이몰드 설비 관련 데이터',
              source: 'Classification',
              labelType: 'Manual',
              state: 'Confirmed',
            },
          ],
          terms: [
            {
              id: 'term-temperature',
              type: 'glossaryTerm',
              name: 'Temperature',
              displayName: '온도',
              fullyQualifiedName: 'Manufacturing.Temperature',
              deleted: false,
            },
            {
              id: 'term-metadata',
              type: 'glossaryTerm',
              name: 'Metadata',
              displayName: '메타데이터',
              fullyQualifiedName: 'DataManagement.Metadata',
              deleted: false,
            },
          ],
          sourceHash: 'ed67df97ee336d78e0f9f3dffb1c5eed',
          followers: [],
          deleted: false,
          service: {
            deleted: false,
            displayName: 'bronze-iceberg',
            name: 'bronze-iceberg',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>Bronze Tier Iceberg</p></li></ul><p></p>',
            id: '04812691-e812-4edb-b69a-960faa6b842f',
            type: 'databaseService',
            fullyQualifiedName: 'bronze-iceberg',
          },
          name: 'gsp_dcs',
          processedLineage: false,
          tagSources: {},
          upstreamLineage: [],
          locationPath: null,
          fqnParts: [
            'g_turbo',
            'g_turbo.gsp_dcs',
            'bronze-iceberg.bronze.g_turbo',
            'bronze-iceberg',
            'bronze-iceberg.bronze.g_turbo.gsp_dcs',
            'bronze.g_turbo',
            'bronze.g_turbo.gsp_dcs',
            'bronze-iceberg.bronze',
            'bronze',
          ],
        },
        sort: [0],
      },
      {
        _index: 'table_search_index',
        _id: '458633f7-21e9-4022-9412-c9adf05747d0',
        _score: null,
        _source: {
          databaseSchema: {
            deleted: false,
            displayName: 'g_turbo',
            name: 'g_turbo',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>가디원 터보 원천 데이터</p><ul class="om-list-disc"><li class="om-leading-normal"><p>베어링 시트지</p></li><li class="om-leading-normal"><p>Chart &amp; Trend 테이블</p></li><li class="om-leading-normal"><p>tag_id / rpm 매핑 테이블 (메타 데이터)</p></li><li class="om-leading-normal"><p>개인 작업용 </p></li><li class="om-leading-normal"><p>etc ..</p><p></p></li></ul></li></ul><p></p>',
            id: '47b43540-aa17-4b11-8f43-d2fb6489ef48',
            type: 'databaseSchema',
            fullyQualifiedName: 'bronze-iceberg.bronze.g_turbo',
          },
          serviceType: 'Iceberg',
          displayName: 'gsp_ecms1_bearings2',
          schemaDefinition: null,
          description:
            '<ul class="om-list-disc"><li class="om-leading-normal"><p>GSP ECMS1 베어링 시트지2</p><ul class="om-list-disc"><li class="om-leading-normal"><p>터빈 베어링 진단 알고리즘에 활용되는 config 정보</p></li></ul></li></ul><p></p>',
          owners: [
            {
              deleted: false,
              displayName: 'DI',
              inherited: true,
              name: 'DI',
              description:
                '<ul class="om-list-disc"><li class="om-leading-normal"><p>데이터 과학자, 분석가 소속 팀</p></li></ul><p></p>',
              id: '3b28a5be-4517-48f0-84f4-01ae147493bd',
              type: 'team',
              fullyQualifiedName: 'DI',
            },
          ],
          tierSources: {},
          fqnHash:
            'd3e099f4de5c79f8999f7fccaf37c881.cab7e764b30007514145eaf2f6a7ed0f.5df9be687e674cc4273916ac1fa9a834.8699e02536cf70ddab2e5eb116c0d3af',
          customMetrics: [],
          tableType: 'Regular',
          database: {
            deleted: false,
            displayName: 'bronze',
            name: 'bronze',
            id: '86937770-97d6-40ea-99b9-d7e30effef15',
            type: 'database',
            fullyQualifiedName: 'bronze-iceberg.bronze',
          },
          descriptionStatus: 'COMPLETE',
          columnNames: [
            'id',
            'rotor_id',
            'train_id',
            'administrator',
            'vms_type',
            'bearing_type',
            'asset_type',
            'critical_speed',
            'rated_speed',
            'direction',
            'neighbor_id',
            'x_tag',
            'y_tag',
            'x_p2p',
            'y_p2p',
            'x_gap_tag',
            'y_gap_tag',
            'x_1x_tag',
            'y_1x_tag',
            'phase_x_tag',
            'phase_y_tag',
            'rpm_tag',
            'process_vib_x',
            'process_vib_y',
            'process_temperature',
            'asset_seq',
            'iso_a',
            'iso_b',
            'iso_c',
            'vib_threshold_h',
            'vib_threshold_hh',
            'temperature_threshold_h',
            'temperature_threshold_hh',
            'source_unit',
            'sensor_x',
            'sensor_y',
            'bearing_order',
            'bearing_name',
          ],
          tier: null,
          totalVotes: 0,
          usageSummary: {
            date: '2026-03-26',
            weeklyStats: {
              percentileRank: 0,
              count: 0,
            },
            monthlyStats: {
              percentileRank: 0,
              count: 0,
            },
            dailyStats: {
              percentileRank: 0,
              count: 0,
            },
          },
          id: '458633f7-21e9-4022-9412-c9adf05747d0',
          columnDescriptionStatus: 'INCOMPLETE',
          upstreamEntityRelationship: [],
          updatedAt: 1761292909194,
          columnNamesFuzzy:
            'id rotor_id train_id administrator vms_type bearing_type asset_type critical_speed rated_speed direction neighbor_id x_tag y_tag x_p2p y_p2p x_gap_tag y_gap_tag x_1x_tag y_1x_tag phase_x_tag phase_y_tag rpm_tag process_vib_x process_vib_y process_temperature asset_seq iso_a iso_b iso_c vib_threshold_h vib_threshold_hh temperature_threshold_h temperature_threshold_hh source_unit sensor_x sensor_y bearing_order bearing_name',
          descriptionSources: {
            Manual: 1,
          },
          updatedBy: 'ingestion-bot',
          entityType: 'table',
          domains: [],
          dataProducts: [],
          fullyQualifiedName: 'bronze-iceberg.bronze.g_turbo.gsp_ecms1_bearings2',
          version: 0.3,
          queries: [],
          certification: {
            tagLabel: {
              tagFQN: 'Certification.Bronze',
              name: 'Bronze',
              labelType: 'Manual',
              description: 'Bronze certified Data Asset',
              style: {
                color: '#C08329',
                iconURL: 'BronzeCertification.svg',
              },
              source: 'Classification',
              state: 'Confirmed',
            },
          },
          tags: [
            {
              tagFQN: 'Equipment Type.CNC_Lathe',
              name: 'CNC_Lathe',
              displayName: 'CNC Lathe',
              description: 'CNC 선반 설비 관련 데이터',
              source: 'Classification',
              labelType: 'Manual',
              state: 'Confirmed',
            },
            {
              tagFQN: 'Equipment Type.사출기',
              name: '사출기',
              displayName: '사출기',
              description: '사출 성형 설비 관련 데이터',
              source: 'Classification',
              labelType: 'Manual',
              state: 'Confirmed',
            },
          ],
          terms: [
            {
              id: 'term-bearing',
              type: 'glossaryTerm',
              name: 'Bearing',
              displayName: '베어링',
              fullyQualifiedName: 'Manufacturing.Bearing',
              deleted: false,
            },
          ],
          sourceHash: '2e6f19fa31403491dfa4d1566def952f',
          followers: [],
          deleted: false,
          service: {
            deleted: false,
            displayName: 'bronze-iceberg',
            name: 'bronze-iceberg',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>Bronze Tier Iceberg</p></li></ul><p></p>',
            id: '04812691-e812-4edb-b69a-960faa6b842f',
            type: 'databaseService',
            fullyQualifiedName: 'bronze-iceberg',
          },
          name: 'gsp_ecms1_bearings2',
          processedLineage: false,
          tagSources: {},
          upstreamLineage: [],
          locationPath: null,
          fqnParts: [
            'g_turbo',
            'bronze-iceberg.bronze.g_turbo.gsp_ecms1_bearings2',
            'bronze.g_turbo.gsp_ecms1_bearings2',
            'bronze-iceberg.bronze.g_turbo',
            'g_turbo.gsp_ecms1_bearings2',
            'bronze-iceberg',
            'bronze.g_turbo',
            'bronze-iceberg.bronze',
            'bronze',
          ],
        },
        sort: [0],
      },
      {
        _index: 'table_search_index',
        _id: 'c71b5d60-f057-404b-aba7-e6e6d6f385ed',
        _score: null,
        _source: {
          databaseSchema: {
            deleted: false,
            displayName: 'g_turbo',
            name: 'g_turbo',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>가디원 터보 원천 데이터</p><ul class="om-list-disc"><li class="om-leading-normal"><p>베어링 시트지</p></li><li class="om-leading-normal"><p>Chart &amp; Trend 테이블</p></li><li class="om-leading-normal"><p>tag_id / rpm 매핑 테이블 (메타 데이터)</p></li><li class="om-leading-normal"><p>개인 작업용 </p></li><li class="om-leading-normal"><p>etc ..</p><p></p></li></ul></li></ul><p></p>',
            id: '47b43540-aa17-4b11-8f43-d2fb6489ef48',
            type: 'databaseSchema',
            fullyQualifiedName: 'bronze-iceberg.bronze.g_turbo',
          },
          serviceType: 'Iceberg',
          displayName: 'gsp_ecms1_bearings1',
          schemaDefinition: null,
          description:
            '<ul class="om-list-disc"><li class="om-leading-normal"><p>GSP ECMS1 베어링 시트지 </p><ul class="om-list-disc"><li class="om-leading-normal"><p>터빈 베어링 진단 알고리즘에 활용되는 config 정보 </p></li></ul></li></ul><p></p>',
          owners: [
            {
              deleted: false,
              displayName: 'DI',
              inherited: true,
              name: 'DI',
              description:
                '<ul class="om-list-disc"><li class="om-leading-normal"><p>데이터 과학자, 분석가 소속 팀</p></li></ul><p></p>',
              id: '3b28a5be-4517-48f0-84f4-01ae147493bd',
              type: 'team',
              fullyQualifiedName: 'DI',
            },
          ],
          tierSources: {},
          fqnHash:
            'd3e099f4de5c79f8999f7fccaf37c881.cab7e764b30007514145eaf2f6a7ed0f.5df9be687e674cc4273916ac1fa9a834.ae65a7f74d9dd2785698b81c39b3aedb',
          customMetrics: [],
          tableType: 'Regular',
          database: {
            deleted: false,
            displayName: 'bronze',
            name: 'bronze',
            id: '86937770-97d6-40ea-99b9-d7e30effef15',
            type: 'database',
            fullyQualifiedName: 'bronze-iceberg.bronze',
          },
          descriptionStatus: 'COMPLETE',
          columnNames: [
            'id',
            'rotor_id',
            'train_id',
            'administrator',
            'vms_type',
            'bearing_type',
            'asset_type',
            'critical_speed',
            'rated_speed',
            'direction',
            'neighbor_id',
            'x_tag',
            'y_tag',
            'x_p2p',
            'y_p2p',
            'x_gap_tag',
            'y_gap_tag',
            'x_1x_tag',
            'y_1x_tag',
            'phase_x_tag',
            'phase_y_tag',
            'rpm_tag',
            'process_vib_x',
            'process_vib_y',
            'process_temperature',
            'asset_seq',
            'iso_a',
            'iso_b',
            'iso_c',
            'vib_threshold_h',
            'vib_threshold_hh',
            'temperature_threshold_h',
            'temperature_threshold_hh',
            'source_unit',
            'sensor_x',
            'sensor_y',
            'bearing_order',
            'bearing_name',
          ],
          tier: null,
          totalVotes: 0,
          usageSummary: {
            date: '2026-03-26',
            weeklyStats: {
              percentileRank: 0,
              count: 0,
            },
            monthlyStats: {
              percentileRank: 0,
              count: 0,
            },
            dailyStats: {
              percentileRank: 0,
              count: 0,
            },
          },
          id: 'c71b5d60-f057-404b-aba7-e6e6d6f385ed',
          columnDescriptionStatus: 'INCOMPLETE',
          upstreamEntityRelationship: [],
          updatedAt: 1761292908383,
          columnNamesFuzzy:
            'id rotor_id train_id administrator vms_type bearing_type asset_type critical_speed rated_speed direction neighbor_id x_tag y_tag x_p2p y_p2p x_gap_tag y_gap_tag x_1x_tag y_1x_tag phase_x_tag phase_y_tag rpm_tag process_vib_x process_vib_y process_temperature asset_seq iso_a iso_b iso_c vib_threshold_h vib_threshold_hh temperature_threshold_h temperature_threshold_hh source_unit sensor_x sensor_y bearing_order bearing_name',
          descriptionSources: {
            Manual: 35,
          },
          updatedBy: 'ingestion-bot',
          entityType: 'table',
          domains: [],
          dataProducts: [],
          fullyQualifiedName: 'bronze-iceberg.bronze.g_turbo.gsp_ecms1_bearings1',
          version: 0.4,
          queries: [],
          certification: {
            tagLabel: {
              tagFQN: 'Certification.Bronze',
              name: 'Bronze',
              labelType: 'Manual',
              description: 'Bronze certified Data Asset',
              style: {
                color: '#C08329',
                iconURL: 'BronzeCertification.svg',
              },
              source: 'Classification',
              state: 'Confirmed',
            },
          },
          tags: [
            {
              tagFQN: 'Equipment Type.CNC_Lathe',
              name: 'CNC_Lathe',
              displayName: 'CNC Lathe',
              description: 'CNC 선반 설비 관련 데이터',
              source: 'Classification',
              labelType: 'Manual',
              state: 'Confirmed',
            },
            {
              tagFQN: 'Equipment Type.터빈',
              name: '터빈',
              displayName: '터빈',
              description: '터빈 설비 관련 데이터',
              source: 'Classification',
              labelType: 'Manual',
              state: 'Confirmed',
            },
          ],
          terms: [
            {
              id: 'term-bearing',
              type: 'glossaryTerm',
              name: 'Bearing',
              displayName: '베어링',
              fullyQualifiedName: 'Manufacturing.Bearing',
              deleted: false,
            },
            {
              id: 'term-vibration',
              type: 'glossaryTerm',
              name: 'Vibration',
              displayName: '진동',
              fullyQualifiedName: 'Manufacturing.Vibration',
              deleted: false,
            },
          ],
          sourceHash: 'ed3f1fb9f2e69827119060cff019f784',
          followers: [],
          deleted: false,
          service: {
            deleted: false,
            displayName: 'bronze-iceberg',
            name: 'bronze-iceberg',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>Bronze Tier Iceberg</p></li></ul><p></p>',
            id: '04812691-e812-4edb-b69a-960faa6b842f',
            type: 'databaseService',
            fullyQualifiedName: 'bronze-iceberg',
          },
          name: 'gsp_ecms1_bearings1',
          processedLineage: false,
          tagSources: {},
          upstreamLineage: [],
          locationPath: null,
          fqnParts: [
            'g_turbo',
            'bronze-iceberg.bronze.g_turbo.gsp_ecms1_bearings1',
            'g_turbo.gsp_ecms1_bearings1',
            'bronze-iceberg.bronze.g_turbo',
            'bronze-iceberg',
            'bronze.g_turbo',
            'bronze-iceberg.bronze',
            'bronze',
            'bronze.g_turbo.gsp_ecms1_bearings1',
          ],
        },
        sort: [0],
      },
      {
        _index: 'table_search_index',
        _id: 'd1d8059f-682e-40a1-bd26-3de2ef111757',
        _score: null,
        _source: {
          databaseSchema: {
            deleted: false,
            displayName: 'g_turbo',
            name: 'g_turbo',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>가디원 터보 원천 데이터</p><ul class="om-list-disc"><li class="om-leading-normal"><p>베어링 시트지</p></li><li class="om-leading-normal"><p>Chart &amp; Trend 테이블</p></li><li class="om-leading-normal"><p>tag_id / rpm 매핑 테이블 (메타 데이터)</p></li><li class="om-leading-normal"><p>개인 작업용 </p></li><li class="om-leading-normal"><p>etc ..</p><p></p></li></ul></li></ul><p></p>',
            id: '47b43540-aa17-4b11-8f43-d2fb6489ef48',
            type: 'databaseSchema',
            fullyQualifiedName: 'bronze-iceberg.bronze.g_turbo',
          },
          serviceType: 'Iceberg',
          displayName: 'hanwha_impact_chart',
          schemaDefinition: null,
          description:
            '<ul class="om-list-disc"><li class="om-leading-normal"><p>한화 임팩트 진동 raw 데이터 테이블</p><ul class="om-list-disc"><li class="om-leading-normal"><p>고객사에서 전달 준 원천 데이터에서 chart 테이블에 맞게 1차 정제를 한 테이블이다.</p></li></ul></li></ul><p></p>',
          owners: [
            {
              deleted: false,
              displayName: 'DI',
              inherited: true,
              name: 'DI',
              description:
                '<ul class="om-list-disc"><li class="om-leading-normal"><p>데이터 과학자, 분석가 소속 팀</p></li></ul><p></p>',
              id: '3b28a5be-4517-48f0-84f4-01ae147493bd',
              type: 'team',
              fullyQualifiedName: 'DI',
            },
          ],
          tierSources: {},
          fqnHash:
            'd3e099f4de5c79f8999f7fccaf37c881.cab7e764b30007514145eaf2f6a7ed0f.5df9be687e674cc4273916ac1fa9a834.4f6b85d9e5c59680a3ced32f7efcadde',
          customMetrics: [],
          tableType: 'Regular',
          database: {
            deleted: false,
            displayName: 'bronze',
            name: 'bronze',
            id: '86937770-97d6-40ea-99b9-d7e30effef15',
            type: 'database',
            fullyQualifiedName: 'bronze-iceberg.bronze',
          },
          descriptionStatus: 'COMPLETE',
          columnNames: [
            'tag_id',
            'meas_start_dt',
            'chart_type',
            'lines',
            'sample_rate',
            'chart_data',
            'rpm',
            'origin_tag_id',
          ],
          tier: null,
          totalVotes: 0,
          usageSummary: {
            date: '2026-03-26',
            weeklyStats: {
              percentileRank: 0,
              count: 0,
            },
            monthlyStats: {
              percentileRank: 0,
              count: 0,
            },
            dailyStats: {
              percentileRank: 0,
              count: 0,
            },
          },
          id: 'd1d8059f-682e-40a1-bd26-3de2ef111757',
          columnDescriptionStatus: 'COMPLETE',
          upstreamEntityRelationship: [],
          updatedAt: 1763359255685,
          columnNamesFuzzy: 'tag_id meas_start_dt chart_type lines sample_rate chart_data rpm origin_tag_id',
          descriptionSources: {
            Ingested: 1,
            Manual: 8,
          },
          updatedBy: 'ingestion-bot',
          entityType: 'table',
          domains: [],
          dataProducts: [],
          fullyQualifiedName: 'bronze-iceberg.bronze.g_turbo.hanwha_impact_chart',
          version: 2.4,
          queries: [],
          certification: {
            tagLabel: {
              tagFQN: 'Certification.Bronze',
              name: 'Bronze',
              labelType: 'Manual',
              description: 'Bronze certified Data Asset',
              style: {
                color: '#C08329',
                iconURL: 'BronzeCertification.svg',
              },
              source: 'Classification',
              state: 'Confirmed',
            },
          },
          tags: [
            {
              tagFQN: 'Equipment Type.Furnace',
              name: 'Furnace',
              displayName: 'Furnace',
              description: '용광로 설비 관련 데이터',
              source: 'Classification',
              labelType: 'Manual',
              state: 'Confirmed',
            },
            {
              tagFQN: 'Equipment Type.Hi-Mold',
              name: 'Hi-Mold',
              displayName: 'Hi-Mold',
              description: '하이몰드 설비 관련 데이터',
              source: 'Classification',
              labelType: 'Manual',
              state: 'Confirmed',
            },
          ],
          terms: [
            {
              id: 'term-vibration',
              type: 'glossaryTerm',
              name: 'Vibration',
              displayName: '진동',
              fullyQualifiedName: 'Manufacturing.Vibration',
              deleted: false,
            },
            {
              id: 'term-temperature',
              type: 'glossaryTerm',
              name: 'Temperature',
              displayName: '온도',
              fullyQualifiedName: 'Manufacturing.Temperature',
              deleted: false,
            },
          ],
          sourceHash: 'fe64a8647e79d780692bf21bc7a655a0',
          followers: [],
          deleted: false,
          service: {
            deleted: false,
            displayName: 'bronze-iceberg',
            name: 'bronze-iceberg',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>Bronze Tier Iceberg</p></li></ul><p></p>',
            id: '04812691-e812-4edb-b69a-960faa6b842f',
            type: 'databaseService',
            fullyQualifiedName: 'bronze-iceberg',
          },
          name: 'hanwha_impact_chart',
          processedLineage: false,
          tablePartition: {
            columns: [
              {
                intervalType: 'INTEGER-RANGE',
                columnName: 'tag_id',
              },
              {
                intervalType: 'COLUMN-VALUE',
                columnName: 'chart_type',
              },
            ],
          },
          tagSources: {},
          upstreamLineage: [],
          locationPath: null,
          fqnParts: [
            'g_turbo',
            'bronze-iceberg.bronze.g_turbo.hanwha_impact_chart',
            'g_turbo.hanwha_impact_chart',
            'bronze-iceberg.bronze.g_turbo',
            'bronze-iceberg',
            'bronze.g_turbo',
            'bronze.g_turbo.hanwha_impact_chart',
            'bronze-iceberg.bronze',
            'bronze',
          ],
        },
        sort: [0],
      },
      {
        _index: 'table_search_index',
        _id: 'd9175052-b735-4a43-a6e5-720bb62dc324',
        _score: null,
        _source: {
          databaseSchema: {
            deleted: false,
            displayName: 'g_turbo',
            name: 'g_turbo',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>가디원 터보 원천 데이터</p><ul class="om-list-disc"><li class="om-leading-normal"><p>베어링 시트지</p></li><li class="om-leading-normal"><p>Chart &amp; Trend 테이블</p></li><li class="om-leading-normal"><p>tag_id / rpm 매핑 테이블 (메타 데이터)</p></li><li class="om-leading-normal"><p>개인 작업용 </p></li><li class="om-leading-normal"><p>etc ..</p><p></p></li></ul></li></ul><p></p>',
            id: '47b43540-aa17-4b11-8f43-d2fb6489ef48',
            type: 'databaseSchema',
            fullyQualifiedName: 'bronze-iceberg.bronze.g_turbo',
          },
          serviceType: 'Iceberg',
          displayName: 'gsp_ecms1_trend',
          schemaDefinition: null,
          description:
            '<ul class="om-list-disc"><li class="om-leading-normal"><p>GSP ECMS1 Trend 테이블</p><ul class="om-list-disc"><li class="om-leading-normal"><p>tag_id에 따른 peak-to-peak 정보를 가지고 있다.</p></li></ul></li></ul><p></p>',
          owners: [
            {
              deleted: false,
              displayName: 'DI',
              inherited: true,
              name: 'DI',
              description:
                '<ul class="om-list-disc"><li class="om-leading-normal"><p>데이터 과학자, 분석가 소속 팀</p></li></ul><p></p>',
              id: '3b28a5be-4517-48f0-84f4-01ae147493bd',
              type: 'team',
              fullyQualifiedName: 'DI',
            },
          ],
          tierSources: {},
          fqnHash:
            'd3e099f4de5c79f8999f7fccaf37c881.cab7e764b30007514145eaf2f6a7ed0f.5df9be687e674cc4273916ac1fa9a834.747f427d015adb9dbc5389bef5b79876',
          customMetrics: [],
          tableType: 'Regular',
          database: {
            deleted: false,
            displayName: 'bronze',
            name: 'bronze',
            id: '86937770-97d6-40ea-99b9-d7e30effef15',
            type: 'database',
            fullyQualifiedName: 'bronze-iceberg.bronze',
          },
          descriptionStatus: 'COMPLETE',
          columnNames: [
            'trend_id',
            'tag_id',
            'meas_dt',
            'mean_val',
            'acq_dt',
            'reg_user_id',
            'reg_dt',
            'alert_yn',
            'phase_val',
          ],
          tier: null,
          totalVotes: 0,
          usageSummary: {
            date: '2026-03-26',
            weeklyStats: {
              percentileRank: 0,
              count: 0,
            },
            monthlyStats: {
              percentileRank: 0,
              count: 0,
            },
            dailyStats: {
              percentileRank: 0,
              count: 0,
            },
          },
          id: 'd9175052-b735-4a43-a6e5-720bb62dc324',
          columnDescriptionStatus: 'INCOMPLETE',
          upstreamEntityRelationship: [],
          updatedAt: 1760667416871,
          columnNamesFuzzy: 'trend_id tag_id meas_dt mean_val acq_dt reg_user_id reg_dt alert_yn phase_val',
          descriptionSources: {
            Manual: 5,
          },
          updatedBy: 'jaejun.lee',
          entityType: 'table',
          domains: [],
          dataProducts: [],
          fullyQualifiedName: 'bronze-iceberg.bronze.g_turbo.gsp_ecms1_trend',
          version: 0.3,
          queries: [],
          certification: {
            tagLabel: {
              tagFQN: 'Certification.Bronze',
              name: 'Bronze',
              labelType: 'Manual',
              description: 'Bronze certified Data Asset',
              style: {
                color: '#C08329',
                iconURL: 'BronzeCertification.svg',
              },
              source: 'Classification',
              state: 'Confirmed',
            },
          },
          tags: [
            {
              tagFQN: 'Equipment Type.CNC_Lathe',
              name: 'CNC_Lathe',
              displayName: 'CNC Lathe',
              description: 'CNC 선반 설비 관련 데이터',
              source: 'Classification',
              labelType: 'Manual',
              state: 'Confirmed',
            },
          ],
          terms: [
            {
              id: 'term-vibration',
              type: 'glossaryTerm',
              name: 'Vibration',
              displayName: '진동',
              fullyQualifiedName: 'Manufacturing.Vibration',
              deleted: false,
            },
            {
              id: 'term-temperature',
              type: 'glossaryTerm',
              name: 'Temperature',
              displayName: '온도',
              fullyQualifiedName: 'Manufacturing.Temperature',
              deleted: false,
            },
          ],
          sourceHash: 'f744cf82261fa930bf2f57fe7ae1d4c4',
          followers: [],
          deleted: false,
          service: {
            deleted: false,
            displayName: 'bronze-iceberg',
            name: 'bronze-iceberg',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>Bronze Tier Iceberg</p></li></ul><p></p>',
            id: '04812691-e812-4edb-b69a-960faa6b842f',
            type: 'databaseService',
            fullyQualifiedName: 'bronze-iceberg',
          },
          name: 'gsp_ecms1_trend',
          processedLineage: false,
          tablePartition: {
            columns: [
              {
                intervalType: 'INTEGER-RANGE',
                columnName: 'tag_id',
              },
            ],
          },
          tagSources: {},
          upstreamLineage: [],
          locationPath: null,
          fqnParts: [
            'g_turbo',
            'bronze.g_turbo.gsp_ecms1_trend',
            'g_turbo.gsp_ecms1_trend',
            'bronze-iceberg.bronze.g_turbo',
            'bronze-iceberg',
            'bronze.g_turbo',
            'bronze-iceberg.bronze.g_turbo.gsp_ecms1_trend',
            'bronze-iceberg.bronze',
            'bronze',
          ],
        },
        sort: [0],
      },
      {
        _index: 'table_search_index',
        _id: 'e796067f-ea82-4045-90b0-b0818ce60132',
        _score: null,
        _source: {
          databaseSchema: {
            deleted: false,
            displayName: 'g_turbo',
            name: 'g_turbo',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>가디원 터보 원천 데이터</p><ul class="om-list-disc"><li class="om-leading-normal"><p>베어링 시트지</p></li><li class="om-leading-normal"><p>Chart &amp; Trend 테이블</p></li><li class="om-leading-normal"><p>tag_id / rpm 매핑 테이블 (메타 데이터)</p></li><li class="om-leading-normal"><p>개인 작업용 </p></li><li class="om-leading-normal"><p>etc ..</p><p></p></li></ul></li></ul><p></p>',
            id: '47b43540-aa17-4b11-8f43-d2fb6489ef48',
            type: 'databaseSchema',
            fullyQualifiedName: 'bronze-iceberg.bronze.g_turbo',
          },
          serviceType: 'Iceberg',
          displayName: 'hanwha_impact_trend',
          schemaDefinition: null,
          description:
            '<ul class="om-list-disc"><li class="om-leading-normal"><p>한화 임팩트 peak to peak 정보를 보유한 테이블</p><ul class="om-list-disc"><li class="om-leading-normal"><p>hanwha_impact_chart 테이블로 부터, peak-to-peak 연산을 통해 만들어졌다.</p></li></ul></li></ul><p></p>',
          owners: [
            {
              deleted: false,
              displayName: 'DI',
              inherited: true,
              name: 'DI',
              description:
                '<ul class="om-list-disc"><li class="om-leading-normal"><p>데이터 과학자, 분석가 소속 팀</p></li></ul><p></p>',
              id: '3b28a5be-4517-48f0-84f4-01ae147493bd',
              type: 'team',
              fullyQualifiedName: 'DI',
            },
          ],
          tierSources: {},
          fqnHash:
            'd3e099f4de5c79f8999f7fccaf37c881.cab7e764b30007514145eaf2f6a7ed0f.5df9be687e674cc4273916ac1fa9a834.e4da57ff8388af16c105ca22295063be',
          customMetrics: [],
          tableType: 'Regular',
          database: {
            deleted: false,
            displayName: 'bronze',
            name: 'bronze',
            id: '86937770-97d6-40ea-99b9-d7e30effef15',
            type: 'database',
            fullyQualifiedName: 'bronze-iceberg.bronze',
          },
          descriptionStatus: 'COMPLETE',
          columnNames: ['tag_id', 'meas_dt', 'mean_val'],
          tier: null,
          totalVotes: 0,
          usageSummary: {
            date: '2026-03-26',
            weeklyStats: {
              percentileRank: 0,
              count: 0,
            },
            monthlyStats: {
              percentileRank: 0,
              count: 0,
            },
            dailyStats: {
              percentileRank: 0,
              count: 0,
            },
          },
          id: 'e796067f-ea82-4045-90b0-b0818ce60132',
          columnDescriptionStatus: 'COMPLETE',
          upstreamEntityRelationship: [],
          updatedAt: 1762250471957,
          columnNamesFuzzy: 'tag_id meas_dt mean_val',
          descriptionSources: {
            Ingested: 1,
            Manual: 3,
          },
          updatedBy: 'ingestion-bot',
          entityType: 'table',
          domains: [],
          dataProducts: [],
          fullyQualifiedName: 'bronze-iceberg.bronze.g_turbo.hanwha_impact_trend',
          version: 1.2,
          queries: [],
          certification: {
            tagLabel: {
              tagFQN: 'Certification.Bronze',
              name: 'Bronze',
              labelType: 'Manual',
              description: 'Bronze certified Data Asset',
              style: {
                color: '#C08329',
                iconURL: 'BronzeCertification.svg',
              },
              source: 'Classification',
              state: 'Confirmed',
            },
          },
          tags: [
            {
              tagFQN: 'Equipment Type.Furnace',
              name: 'Furnace',
              displayName: 'Furnace',
              description: '용광로 설비 관련 데이터',
              source: 'Classification',
              labelType: 'Manual',
              state: 'Confirmed',
            },
          ],
          terms: [
            {
              id: 'term-vibration',
              type: 'glossaryTerm',
              name: 'Vibration',
              displayName: '진동',
              fullyQualifiedName: 'Manufacturing.Vibration',
              deleted: false,
            },
            {
              id: 'term-temperature',
              type: 'glossaryTerm',
              name: 'Temperature',
              displayName: '온도',
              fullyQualifiedName: 'Manufacturing.Temperature',
              deleted: false,
            },
          ],
          sourceHash: 'f3d02a6868b34ef8056b422b5b72b69b',
          followers: [],
          deleted: false,
          service: {
            deleted: false,
            displayName: 'bronze-iceberg',
            name: 'bronze-iceberg',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>Bronze Tier Iceberg</p></li></ul><p></p>',
            id: '04812691-e812-4edb-b69a-960faa6b842f',
            type: 'databaseService',
            fullyQualifiedName: 'bronze-iceberg',
          },
          name: 'hanwha_impact_trend',
          processedLineage: false,
          tagSources: {},
          upstreamLineage: [],
          locationPath: null,
          fqnParts: [
            'g_turbo',
            'bronze-iceberg.bronze.g_turbo.hanwha_impact_trend',
            'bronze.g_turbo.hanwha_impact_trend',
            'bronze-iceberg.bronze.g_turbo',
            'g_turbo.hanwha_impact_trend',
            'bronze-iceberg',
            'bronze.g_turbo',
            'bronze-iceberg.bronze',
            'bronze',
          ],
        },
        sort: [0],
      },
      {
        _index: 'table_search_index',
        _id: '817b6c60-1fdd-4d0e-9ede-cda25a52d7af',
        _score: null,
        _source: {
          databaseSchema: {
            deleted: false,
            displayName: 'g_turbo',
            name: 'g_turbo',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>가디원 터보 원천 데이터</p><ul class="om-list-disc"><li class="om-leading-normal"><p>베어링 시트지</p></li><li class="om-leading-normal"><p>Chart &amp; Trend 테이블</p></li><li class="om-leading-normal"><p>tag_id / rpm 매핑 테이블 (메타 데이터)</p></li><li class="om-leading-normal"><p>개인 작업용 </p></li><li class="om-leading-normal"><p>etc ..</p><p></p></li></ul></li></ul><p></p>',
            id: '47b43540-aa17-4b11-8f43-d2fb6489ef48',
            type: 'databaseSchema',
            fullyQualifiedName: 'bronze-iceberg.bronze.g_turbo',
          },
          serviceType: 'Iceberg',
          displayName: 'tag_id_mapping_table',
          schemaDefinition: null,
          description:
            '<ul class="om-list-disc"><li class="om-leading-normal"><p>tag_id가 String으로 받아질 경우, Integer로 매핑 하기 위해 만들어진 테이블 (메타 데이터)</p><ul class="om-list-disc"><li class="om-leading-normal"><p>gturbo 표준화 - 정제 로직을 수행하기 위해 최소한의 테이블 스키마를 맞춰주기 위해서 만들어졌다.</p></li></ul></li></ul><p></p>',
          owners: [
            {
              deleted: false,
              displayName: 'DI',
              inherited: true,
              name: 'DI',
              description:
                '<ul class="om-list-disc"><li class="om-leading-normal"><p>데이터 과학자, 분석가 소속 팀</p></li></ul><p></p>',
              id: '3b28a5be-4517-48f0-84f4-01ae147493bd',
              type: 'team',
              fullyQualifiedName: 'DI',
            },
          ],
          tierSources: {},
          fqnHash:
            'd3e099f4de5c79f8999f7fccaf37c881.cab7e764b30007514145eaf2f6a7ed0f.5df9be687e674cc4273916ac1fa9a834.fedd6f7ceabb9a18da4ef495d2cdf15e',
          customMetrics: [],
          tableType: 'Regular',
          database: {
            deleted: false,
            displayName: 'bronze',
            name: 'bronze',
            id: '86937770-97d6-40ea-99b9-d7e30effef15',
            type: 'database',
            fullyQualifiedName: 'bronze-iceberg.bronze',
          },
          descriptionStatus: 'COMPLETE',
          columnNames: ['id', 'tag_id'],
          tier: null,
          totalVotes: 0,
          usageSummary: {
            date: '2026-03-26',
            weeklyStats: {
              percentileRank: 0,
              count: 0,
            },
            monthlyStats: {
              percentileRank: 0,
              count: 0,
            },
            dailyStats: {
              percentileRank: 0,
              count: 0,
            },
          },
          id: '817b6c60-1fdd-4d0e-9ede-cda25a52d7af',
          columnDescriptionStatus: 'COMPLETE',
          upstreamEntityRelationship: [],
          updatedAt: 1761614889377,
          columnNamesFuzzy: 'id tag_id',
          descriptionSources: {
            Manual: 3,
          },
          updatedBy: 'jaejun.lee',
          entityType: 'table',
          domains: [],
          dataProducts: [],
          fullyQualifiedName: 'bronze-iceberg.bronze.g_turbo.tag_id_mapping_table',
          version: 0.3,
          queries: [],
          certification: {
            tagLabel: {
              tagFQN: 'Certification.Bronze',
              name: 'Bronze',
              labelType: 'Manual',
              description: 'Bronze certified Data Asset',
              style: {
                color: '#C08329',
                iconURL: 'BronzeCertification.svg',
              },
              source: 'Classification',
              state: 'Confirmed',
            },
          },
          tags: [
            {
              tagFQN: 'Equipment Type.터빈',
              name: '터빈',
              displayName: '터빈',
              description: '터빈 설비 관련 데이터',
              source: 'Classification',
              labelType: 'Manual',
              state: 'Confirmed',
            },
            {
              tagFQN: 'Equipment Type.CNC_Lathe',
              name: 'CNC_Lathe',
              displayName: 'CNC Lathe',
              description: 'CNC 선반 설비 관련 데이터',
              source: 'Classification',
              labelType: 'Manual',
              state: 'Confirmed',
            },
          ],
          terms: [
            {
              id: 'term-metadata',
              type: 'glossaryTerm',
              name: 'Metadata',
              displayName: '메타데이터',
              fullyQualifiedName: 'DataManagement.Metadata',
              deleted: false,
            },
          ],
          sourceHash: '68732ed4bbcc09224d77911195606693',
          followers: [],
          deleted: false,
          service: {
            deleted: false,
            displayName: 'bronze-iceberg',
            name: 'bronze-iceberg',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>Bronze Tier Iceberg</p></li></ul><p></p>',
            id: '04812691-e812-4edb-b69a-960faa6b842f',
            type: 'databaseService',
            fullyQualifiedName: 'bronze-iceberg',
          },
          name: 'tag_id_mapping_table',
          processedLineage: false,
          tagSources: {},
          upstreamLineage: [],
          locationPath: null,
          fqnParts: [
            'g_turbo',
            'g_turbo.tag_id_mapping_table',
            'bronze.g_turbo.tag_id_mapping_table',
            'bronze-iceberg.bronze.g_turbo',
            'bronze-iceberg.bronze.g_turbo.tag_id_mapping_table',
            'bronze-iceberg',
            'bronze.g_turbo',
            'bronze-iceberg.bronze',
            'bronze',
          ],
        },
        highlight: {
          displayName: ['tag_id_mapping_<span class="text-highlighter">table</span>'],
          name: ['tag_id_mapping_<span class="text-highlighter">table</span>'],
        },
        sort: [0],
      },
      {
        _index: 'table_search_index',
        _id: '0abb6d20-9e11-40fd-8ff1-b7edefcce0e3',
        _score: null,
        _source: {
          databaseSchema: {
            deleted: false,
            displayName: 'g_turbo',
            name: 'g_turbo',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>가디원 터보 원천 데이터</p><ul class="om-list-disc"><li class="om-leading-normal"><p>베어링 시트지</p></li><li class="om-leading-normal"><p>Chart &amp; Trend 테이블</p></li><li class="om-leading-normal"><p>tag_id / rpm 매핑 테이블 (메타 데이터)</p></li><li class="om-leading-normal"><p>개인 작업용 </p></li><li class="om-leading-normal"><p>etc ..</p><p></p></li></ul></li></ul><p></p>',
            id: '47b43540-aa17-4b11-8f43-d2fb6489ef48',
            type: 'databaseSchema',
            fullyQualifiedName: 'bronze-iceberg.bronze.g_turbo',
          },
          serviceType: 'Iceberg',
          displayName: 'kmp_ecms_chart',
          schemaDefinition: null,
          description:
            '<ul class="om-list-disc"><li class="om-leading-normal"><p>KMP 진동 raw 데이터 테이블 (ECMS)</p></li></ul><p></p>',
          owners: [
            {
              deleted: false,
              displayName: 'DI',
              inherited: true,
              name: 'DI',
              description:
                '<ul class="om-list-disc"><li class="om-leading-normal"><p>데이터 과학자, 분석가 소속 팀</p></li></ul><p></p>',
              id: '3b28a5be-4517-48f0-84f4-01ae147493bd',
              type: 'team',
              fullyQualifiedName: 'DI',
            },
          ],
          tierSources: {},
          fqnHash:
            'd3e099f4de5c79f8999f7fccaf37c881.cab7e764b30007514145eaf2f6a7ed0f.5df9be687e674cc4273916ac1fa9a834.7710d2797576f72765e7f35d96948e08',
          customMetrics: [],
          tableType: 'Regular',
          database: {
            deleted: false,
            displayName: 'bronze',
            name: 'bronze',
            id: '86937770-97d6-40ea-99b9-d7e30effef15',
            type: 'database',
            fullyQualifiedName: 'bronze-iceberg.bronze',
          },
          descriptionStatus: 'COMPLETE',
          columnNames: ['tag_id', 'meas_start_dt', 'chart_type', 'lines', 'sample_rate', 'chart_data', 'rpm'],
          tier: null,
          totalVotes: 0,
          usageSummary: {
            date: '2026-03-26',
            weeklyStats: {
              percentileRank: 0,
              count: 0,
            },
            monthlyStats: {
              percentileRank: 0,
              count: 0,
            },
            dailyStats: {
              percentileRank: 0,
              count: 0,
            },
          },
          id: '0abb6d20-9e11-40fd-8ff1-b7edefcce0e3',
          columnDescriptionStatus: 'INCOMPLETE',
          upstreamEntityRelationship: [],
          updatedAt: 1767664596392,
          columnNamesFuzzy: 'tag_id meas_start_dt chart_type lines sample_rate chart_data rpm',
          descriptionSources: {
            Manual: 1,
          },
          updatedBy: 'jaejun.lee',
          entityType: 'table',
          domains: [],
          dataProducts: [],
          fullyQualifiedName: 'bronze-iceberg.bronze.g_turbo.kmp_ecms_chart',
          version: 0.2,
          queries: [],
          certification: {
            tagLabel: {
              tagFQN: 'Certification.Bronze',
              name: 'Bronze',
              labelType: 'Manual',
              description: 'Bronze certified Data Asset',
              style: {
                color: '#C08329',
                iconURL: 'BronzeCertification.svg',
              },
              source: 'Classification',
              state: 'Confirmed',
            },
          },
          tags: [
            {
              tagFQN: 'Equipment Type.CNC_Lathe',
              name: 'CNC_Lathe',
              displayName: 'CNC Lathe',
              description: 'CNC 선반 설비 관련 데이터',
              source: 'Classification',
              labelType: 'Manual',
              state: 'Confirmed',
            },
          ],
          terms: [
            {
              id: 'term-vibration',
              type: 'glossaryTerm',
              name: 'Vibration',
              displayName: '진동',
              fullyQualifiedName: 'Manufacturing.Vibration',
              deleted: false,
            },
            {
              id: 'term-temperature',
              type: 'glossaryTerm',
              name: 'Temperature',
              displayName: '온도',
              fullyQualifiedName: 'Manufacturing.Temperature',
              deleted: false,
            },
          ],
          sourceHash: '7a4fbd258d6151704871d16c022c254f',
          followers: [],
          deleted: false,
          service: {
            deleted: false,
            displayName: 'bronze-iceberg',
            name: 'bronze-iceberg',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>Bronze Tier Iceberg</p></li></ul><p></p>',
            id: '04812691-e812-4edb-b69a-960faa6b842f',
            type: 'databaseService',
            fullyQualifiedName: 'bronze-iceberg',
          },
          name: 'kmp_ecms_chart',
          processedLineage: false,
          tablePartition: {
            columns: [
              {
                intervalType: 'INTEGER-RANGE',
                columnName: 'tag_id',
              },
              {
                intervalType: 'COLUMN-VALUE',
                columnName: 'chart_type',
              },
            ],
          },
          tagSources: {},
          upstreamLineage: [],
          locationPath: null,
          fqnParts: [
            'g_turbo',
            'bronze-iceberg.bronze.g_turbo.kmp_ecms_chart',
            'bronze-iceberg.bronze.g_turbo',
            'bronze-iceberg',
            'bronze.g_turbo',
            'g_turbo.kmp_ecms_chart',
            'bronze.g_turbo.kmp_ecms_chart',
            'bronze-iceberg.bronze',
            'bronze',
          ],
        },
        sort: [0],
      },
      {
        _index: 'table_search_index',
        _id: '245175dc-c3e0-4f42-8786-095445e7094f',
        _score: null,
        _source: {
          databaseSchema: {
            deleted: false,
            displayName: 'g_turbo',
            name: 'g_turbo',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>가디원 터보 원천 데이터</p><ul class="om-list-disc"><li class="om-leading-normal"><p>베어링 시트지</p></li><li class="om-leading-normal"><p>Chart &amp; Trend 테이블</p></li><li class="om-leading-normal"><p>tag_id / rpm 매핑 테이블 (메타 데이터)</p></li><li class="om-leading-normal"><p>개인 작업용 </p></li><li class="om-leading-normal"><p>etc ..</p><p></p></li></ul></li></ul><p></p>',
            id: '47b43540-aa17-4b11-8f43-d2fb6489ef48',
            type: 'databaseSchema',
            fullyQualifiedName: 'bronze-iceberg.bronze.g_turbo',
          },
          serviceType: 'Iceberg',
          displayName: 'hanwha_impact_rpm_tag_id_map',
          schemaDefinition: null,
          description:
            '<ul class="om-list-disc"><li class="om-leading-normal"><p>tag_id 와 rpm 정보를 매핑 하는 테이블 (메타 데이터)</p><ul class="om-list-disc"><li class="om-leading-normal"><p>gturbo 표준화 - 정제 로직을 수행하기 위해 최소한의 테이블 스키마를 맞춰주기 위해서 만들어졌다.</p></li></ul></li></ul><p></p>',
          owners: [
            {
              deleted: false,
              displayName: 'DI',
              inherited: true,
              name: 'DI',
              description:
                '<ul class="om-list-disc"><li class="om-leading-normal"><p>데이터 과학자, 분석가 소속 팀</p></li></ul><p></p>',
              id: '3b28a5be-4517-48f0-84f4-01ae147493bd',
              type: 'team',
              fullyQualifiedName: 'DI',
            },
          ],
          tierSources: {},
          fqnHash:
            'd3e099f4de5c79f8999f7fccaf37c881.cab7e764b30007514145eaf2f6a7ed0f.5df9be687e674cc4273916ac1fa9a834.c4015161362176fc2d9daf597bb38408',
          customMetrics: [],
          tableType: 'Regular',
          database: {
            deleted: false,
            displayName: 'bronze',
            name: 'bronze',
            id: '86937770-97d6-40ea-99b9-d7e30effef15',
            type: 'database',
            fullyQualifiedName: 'bronze-iceberg.bronze',
          },
          descriptionStatus: 'COMPLETE',
          columnNames: ['tag_id', 'rpm'],
          tier: null,
          totalVotes: 0,
          usageSummary: {
            date: '2026-03-26',
            weeklyStats: {
              percentileRank: 0,
              count: 0,
            },
            monthlyStats: {
              percentileRank: 0,
              count: 0,
            },
            dailyStats: {
              percentileRank: 0,
              count: 0,
            },
          },
          id: '245175dc-c3e0-4f42-8786-095445e7094f',
          columnDescriptionStatus: 'COMPLETE',
          upstreamEntityRelationship: [],
          updatedAt: 1761614950913,
          columnNamesFuzzy: 'tag_id rpm',
          descriptionSources: {
            Manual: 3,
          },
          updatedBy: 'jaejun.lee',
          entityType: 'table',
          domains: [],
          dataProducts: [],
          fullyQualifiedName: 'bronze-iceberg.bronze.g_turbo.hanwha_impact_rpm_tag_id_map',
          version: 0.3,
          queries: [],
          certification: {
            tagLabel: {
              tagFQN: 'Certification.Bronze',
              name: 'Bronze',
              labelType: 'Manual',
              description: 'Bronze certified Data Asset',
              style: {
                color: '#C08329',
                iconURL: 'BronzeCertification.svg',
              },
              source: 'Classification',
              state: 'Confirmed',
            },
          },
          tags: [
            {
              tagFQN: 'Equipment Type.Furnace',
              name: 'Furnace',
              displayName: 'Furnace',
              description: '용광로 설비 관련 데이터',
              source: 'Classification',
              labelType: 'Manual',
              state: 'Confirmed',
            },
          ],
          terms: [
            {
              id: 'term-metadata',
              type: 'glossaryTerm',
              name: 'Metadata',
              displayName: '메타데이터',
              fullyQualifiedName: 'DataManagement.Metadata',
              deleted: false,
            },
          ],
          sourceHash: '675c2cbd3a038cd8d35ef35614d8f9e1',
          followers: [],
          deleted: false,
          service: {
            deleted: false,
            displayName: 'bronze-iceberg',
            name: 'bronze-iceberg',
            description:
              '<ul class="om-list-disc"><li class="om-leading-normal"><p>Bronze Tier Iceberg</p></li></ul><p></p>',
            id: '04812691-e812-4edb-b69a-960faa6b842f',
            type: 'databaseService',
            fullyQualifiedName: 'bronze-iceberg',
          },
          name: 'hanwha_impact_rpm_tag_id_map',
          processedLineage: false,
          tagSources: {},
          upstreamLineage: [],
          locationPath: null,
          fqnParts: [
            'g_turbo',
            'bronze-iceberg.bronze.g_turbo.hanwha_impact_rpm_tag_id_map',
            'bronze.g_turbo.hanwha_impact_rpm_tag_id_map',
            'g_turbo.hanwha_impact_rpm_tag_id_map',
            'bronze-iceberg.bronze.g_turbo',
            'bronze-iceberg',
            'bronze.g_turbo',
            'bronze-iceberg.bronze',
            'bronze',
          ],
        },
        sort: [0],
      },
    ],
  },
  aggregations: {
    'sterms#serviceType': {
      doc_count_error_upper_bound: 0,
      sum_other_doc_count: 0,
      buckets: [
        {
          key: 'iceberg',
          doc_count: 14,
        },
      ],
    },
    'sterms#databaseSchema.name.keyword': {
      doc_count_error_upper_bound: 0,
      sum_other_doc_count: 0,
      buckets: [
        {
          key: 'g_turbo',
          doc_count: 14,
        },
      ],
    },
    'sterms#tags.tagFQN': {
      doc_count_error_upper_bound: 0,
      sum_other_doc_count: 0,
      buckets: [],
    },
    'sterms#databaseSchema.displayName': {
      doc_count_error_upper_bound: 0,
      sum_other_doc_count: 0,
      buckets: [
        {
          key: 'g_turbo',
          doc_count: 14,
        },
      ],
    },
    'sterms#entityType': {
      doc_count_error_upper_bound: 0,
      sum_other_doc_count: 0,
      buckets: [
        {
          key: 'table',
          doc_count: 14,
        },
      ],
    },
    'sterms#entityType.keyword': {
      doc_count_error_upper_bound: 0,
      sum_other_doc_count: 0,
      buckets: [
        {
          key: 'table',
          doc_count: 14,
        },
      ],
    },
    'sterms#domain.displayName.keyword': {
      doc_count_error_upper_bound: 0,
      sum_other_doc_count: 0,
      buckets: [],
    },
    'sterms#tier.tagFQN': {
      doc_count_error_upper_bound: 0,
      sum_other_doc_count: 0,
      buckets: [],
    },
    'sterms#service.displayName.keyword': {
      doc_count_error_upper_bound: 0,
      sum_other_doc_count: 0,
      buckets: [
        {
          key: 'bronze-iceberg',
          doc_count: 14,
        },
      ],
    },
    'sterms#database.displayName': {
      doc_count_error_upper_bound: 0,
      sum_other_doc_count: 0,
      buckets: [
        {
          key: 'bronze',
          doc_count: 14,
        },
      ],
    },
    'sterms#database.name.keyword': {
      doc_count_error_upper_bound: 0,
      sum_other_doc_count: 0,
      buckets: [
        {
          key: 'bronze',
          doc_count: 14,
        },
      ],
    },
    'sterms#certification.tagLabel.tagFQN': {
      doc_count_error_upper_bound: 0,
      sum_other_doc_count: 0,
      buckets: [],
    },
    'sterms#owners.displayName.keyword': {
      doc_count_error_upper_bound: 0,
      sum_other_doc_count: 0,
      buckets: [
        {
          key: 'di',
          doc_count: 14,
        },
      ],
    },
  },
};
